import React, { useState, useEffect } from "react";

import api from "../services/api";
export const AuthContext = React.createContext({});

export const AuthProvider = (props) => {
  const [user, setUser] = useState({});
  const [isLoadingUser, setIsLoadingUser] = useState(true);

  async function getPerfil() {
    try {
      let response = await api.get("/meuperfil");
     
      const userData = {
        nome: response.data.name,
        nivel: response.data.type,
        id: response.data.id,
        turma: response.data.turma_id,
        plano: response.data.plan,
        comprou_ebook: response.data.comprou_ebook || false,
        data_limite: response.data.data_limite
      };
      
      setUser(userData);

    } catch (err) {
      // Em caso de erro, considera como carregamento concluído
      console.error("Erro ao carregar perfil:", err);
    } finally {
      setIsLoadingUser(false);
    }
  }

  useEffect(() => {
    if (localStorage.getItem("token")) {
      if(!user.id){
        getPerfil();
      } else {
        // Se já tem usuário carregado, não está mais carregando
        setIsLoadingUser(false);
      }
    } else {
      // Se não tem token, não está carregando
      setIsLoadingUser(false);
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, isLoadingUser }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => React.useContext(AuthContext);
